import React from 'react'
import { Tabs } from 'antd'
import PersonalBankVerify from './Personal'
import BusinessBankVerify from './Business'

function Affiliate(props) {
    const { ln_t } = props
    
    const tabMenu = [
        {
            title: ln_t('affiliate.tabMenu.personal'), 
            key: 'personal', 
            render: <PersonalBankVerify {...props} />
        },
        {
            title: ln_t('affiliate.tabMenu.business'), 
            key: 'business', 
            render: <BusinessBankVerify {...props} />
        },
    ]

    return (
        <div className="card-container">
            <Tabs defaultActiveKey="personal" type="card">
                {tabMenu.map(({ key, title, render }) => (
                    <Tabs.TabPane key={key} tab={title}>
                        {render}
                    </Tabs.TabPane>
                ))}
            </Tabs>
        </div>
    )
}

export default Affiliate
